import { render } from "./step1.vue?vue&type=template&id=13546fd5&scoped=true"
import script from "./step1.vue?vue&type=script&lang=js"
export * from "./step1.vue?vue&type=script&lang=js"

import "./step1.vue?vue&type=style&index=0&id=13546fd5&lang=scss&scoped=true"
import "./step1.vue?vue&type=style&index=1&id=13546fd5&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13546fd5"]])

export default __exports__